import { useState } from "react";
import { useAuth } from "../lib/auth-context";
import { useNav, T, Btn, Input, ErrorMsg } from "../components/shared";

export function AuthPage({ mode }: { mode: "login" | "signup" }) {
  const { login, register } = useAuth();
  const { setView } = useNav();
  const [email,    setEmail]    = useState("");
  const [password, setPassword] = useState("");
  const [name,     setName]     = useState("");
  const [err,      setErr]      = useState("");
  const [loading,  setLoading]  = useState(false);

  const handle = async () => {
    if (!email || !password || (mode === "signup" && !name)) {
      setErr("Please fill in all fields."); return;
    }
    if (mode === "signup" && password.length < 8) {
      setErr("Password must be at least 8 characters."); return;
    }
    setLoading(true); setErr("");
    try {
      if (mode === "login") {
        const u = await login(email, password);
        setView(u?.role === "admin" ? "admin-dash" : "member-dash");
      } else {
        await register(name, email, password);
        setView("member-dash");
      }
    } catch (e: any) {
      setErr(e.message ?? "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: "100vh", background: T.forestDeep, display: "flex", alignItems: "center", justifyContent: "center", paddingTop: 72 }}>
      <div style={{ background: T.ivory, width: "100%", maxWidth: 440, padding: "52px 44px" }} className="fade-in">
        <div onClick={() => setView("home")} style={{ fontFamily: "'Cinzel',serif", fontSize: ".85rem", letterSpacing: ".35em", textTransform: "uppercase", color: T.forest, marginBottom: 36, cursor: "pointer" }}>← Provenance</div>
        <h2 style={{ fontFamily: "'Cormorant',serif", fontSize: "2.2rem", fontWeight: 300, color: T.forestDeep, marginBottom: 4 }}>
          {mode === "login" ? "Welcome back." : "Create your account."}
        </h2>
        <p style={{ fontFamily: "'Libre Baskerville',serif", fontStyle: "italic", fontSize: ".82rem", color: T.mist, marginBottom: 36 }}>
          {mode === "login" ? "Sign in to your account." : "Join Provenance. Choose your membership after signing up."}
        </p>

        {mode === "signup" && <Input label="Full Name" value={name} onChange={setName} required />}
        <Input label="Email" type="email" value={email} onChange={setEmail} required />
        <Input label="Password" type="password" value={password} onChange={setPassword} required />

        {err && <ErrorMsg msg={err} />}

        <Btn onClick={handle} disabled={loading} style={{ width: "100%" }}>
          {loading ? "Please wait…" : mode === "login" ? "Sign In" : "Create Account"}
        </Btn>

        <p style={{ fontSize: ".7rem", color: T.mist, marginTop: 20, textAlign: "center" }}>
          {mode === "login"
            ? <><span onClick={() => setView("signup")} style={{ color: T.brass, cursor: "pointer" }}>Create an account →</span></>
            : <><span onClick={() => setView("login")} style={{ color: T.brass, cursor: "pointer" }}>Already have an account? Sign in →</span></>
          }
        </p>
      </div>
    </div>
  );
}
